// extracted by mini-css-extract-plugin
module.exports = {"noAvatar":"_26GFJ","avatarImage":"ffb2m","hidden":"_7JIP9","qsAvatarWrapper":"RHKSn","small":"k1dzN","medium":"_8B4NX"};